enum CannabisPrimaryRoute {
    Smoke = "Smoke",
    Vaporize = "Vaporize",
    EdibleSlashOral = "EdibleSlashOral",
    Other = "Other"
}

export { CannabisPrimaryRoute };
